/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React from "react";
import PropTypes from "prop-types";
import { generateOnHandlerMethods, extendsAccesibility } from "./utils";

const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

const appendHost = (href) => {
  if (href.indexOf("http") === -1 && href.indexOf("//") === -1) {
    if (currentEnv === "dev") {
      href = `http://127.0.0.1:8089${href}`;
    }
  }

  if (
    href &&
    href.indexOf("#") === -1 &&
    href.indexOf("?") === -1 &&
    href.indexOf(".") === -1 &&
    href[href.length - 1] !== "/"
  ) {
    href = `${href}/`;
  }
  return href;
};

const getReadyLinkForDev = (href) => {
  let devLink = href;
  const projectBasePath = `${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`;
  // eliminamos el basename del proyecto
  if (
    projectBasePath !== "/" &&
    href.indexOf("http") === -1 &&
    href.indexOf("//") === -1
  ) {
    devLink = href.replace(`${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`, "");
  }

  if (!devLink) {
    devLink = "/";
  }

  if (
    devLink &&
    devLink.indexOf("#") === -1 &&
    devLink.indexOf("?") === -1 &&
    devLink.indexOf(".") === -1 &&
    devLink[devLink.length - 1] !== "/"
  ) {
    devLink = `${devLink}/`;
  }

  return devLink;
};

const checkIfHasHrefOperators = (href) => {
  let result = false;
  const OPERATORS = ["tel:", "mailto:"];
  OPERATORS.forEach((item) => {
    if (!result && href.indexOf(item) > -1) {
      result = true;
    }
  });
  return result;
};

/**
 * @name NextLink
 * @description atomic component
 * @see {@link https://nextjs.org/docs/api-reference/next/link}
 * @param {LinkProps} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */

const NextLink = ({
  id,
  children,
  className,
  internal,
  href,
  taggingInfo,
  title: cmpTitle,
  target,
  ariaLabel: cmpAriaLabel,
  screenReadable: cmpScreenRedable,
  style,
  onClick,
  buttonParent,
  buttonTypeHtml,
  disabled,
  custoObjectInfo,
  cyData,
}) => {
  let currentClassName = `next-link${className ? ` ${className}` : ""}`;
  const finalCssName = !children
    ? `${currentClassName} nextLinkOverBox`
    : currentClassName;

  const { title, ariaLabel, ariaHidden } = extendsAccesibility({
    cmpTitle,
    cmpAriaLabel,
    cmpScreenRedable,
    taggingInfo,
  });
  /* wrapeamos funciones ejecutadoras */
  const {
    newOnClick: onClickHandler,
    newOnKeyDown: onKeyDownHandler,
    newOnMouseDown: onMouseDownHandler,
  } = generateOnHandlerMethods({
    onClick,
    taggingInfo,
    disabled,
  });

  // personalizo
  if (custoObjectInfo) {
    currentClassName = `${currentClassName} custo-editable`;
    if (children) {
      return (
        <div
          className={currentClassName}
          onClick={() => custoObjectInfo.handler(custoObjectInfo.entryPoint)}
        >
          {children}
          <style jsx>{`.nextLinkOverBox {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
`}</style>
        </div>
      );
    }
    return (
      <div
        className={currentClassName}
        onClick={() => custoObjectInfo.handler(custoObjectInfo.entryPoint)}
      >
        Enlace
        {/* INJECT_STYLED_JSX_TAG */}
      </div>
    );
  }

  // 0) vemos si tiene href sino tiene solo es un elemento para taggear (TODO)
  if ((!href && onClick) || buttonTypeHtml === "submit") {
    return (
      <button
        id={id || null}
        type={buttonTypeHtml}
        className={finalCssName}
        tabIndex={0}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
        title={title}
        onClick={onClickHandler}
        onKeyDown={onKeyDownHandler}
        onMouseDown={onMouseDownHandler}
        disabled={disabled}
        style={style}
        data-cy={cyData}
      >
        {buttonParent && <div className="hover-layer" />}
        {children}
        <style jsx global>{`.nextLinkOverBox {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
`}</style>
      </button>
    );
  }

  const hasOperators = checkIfHasHrefOperators(href);
  // "2 ) logica de link as usual"
  if (!internal && currentEnv === "dev" && !hasOperators) {
    href = getReadyLinkForDev(href);
  }

  if (!internal && currentEnv !== "dev" && !hasOperators) {
    href = appendHost(href);
  }

  return (
    <a
      id={id || null}
      className={finalCssName}
      tabIndex={0}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      title={title}
      href={href}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : ""}
      onClick={onClickHandler}
      onKeyDown={onKeyDownHandler}
      onMouseDown={onMouseDownHandler}
      disabled={disabled}
      style={style}
      data-cy={cyData}
    >
      {buttonParent && <div className="hover-layer" />}
      {children}
      {/* INJECT_STYLED_JSX_TAG_GLOBAL */}
    </a>
  );
};

NextLink.propTypes = {
  /**
   * Id del componente.
   */
  id: PropTypes.string,
  /**
   * Enlace al que se quiere redireccionar.
   */
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Función que se quiere ejecutar al clickar el componente.
   */
  onClick: PropTypes.func,
  /**
   * Clase para estilos adicionales.
   */
  className: PropTypes.string,
  /**
   * Información para el tagueado del componente.
   */
  taggingInfo: PropTypes.object.isRequired,
  /**
   * Comportamiento para cuando se utiliza href, por defecto
   * es _self pero se puede cambiar a _blank si se quiere que
   * el enlace se abra en una nueva pestaña.
   */
  target: PropTypes.string,
  /**
   * Texto que se muestra al pasar el ratón por encima del componente.
   *  Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
   */
  title: PropTypes.string,
  /**
   * Proporciona una descripción
   * precisa y concisa del contenido del elemento para usuarios de
   * tecnologías de asistencia, como lectores de pantalla, que
   * no pueden ver o interpretar el contenido visual.
   * Primero utiliza taggingInfo.componentContent y si es nulo utiliza este atributo.
   */
  ariaLabel: PropTypes.string,
  /**
   * Deshabilita el componente (solo en ocasiones que se utiliza onClick).
   */
  disabled: PropTypes.bool,
  /**
   *  Cuando se establece en true, indica que el elemento no debe ser presentado visualmente o leído por el lector de pantalla.
   */
  screenReadable: PropTypes.bool,
  /**
   * Establece el tipo de elemento cuando usamos onClick.
   */
  buttonTypeHtml: PropTypes.string,
  /**
   * Parámetros para componente button (ignorar).
   */
  buttonParent: PropTypes.bool,
  /**
   * Parámetros para componente button (ignorar).
   */
  style: PropTypes.object,
  cyData: PropTypes.string,
  internal: PropTypes.bool,
};

NextLink.defaultProps = {
  id: null,
  className: "",
  target: "_self",
  screenReadable: true,
  disabled: false,
  onClick: null,
  buttonTypeHtml: "button",
  buttonParent: false,
  style: {},
  cyData: "",
  internal: false,
};

export default NextLink;
